import { isSameOrContains } from 'anodum';
import view from '../../view';
import { connectedStore } from '../../store';

import getLiveElement from '../accessors/get-live-element';
import pickUpIframe from '../utils/helpers/pick-up-iframe';
import pickUpPhoneLink from '../utils/helpers/pick-up-phone-link';
import getNotDisabledLiveElement from '../utils/helpers/get-not-disabled-live-element.js';

const elementHoverHandler = (event) => {
  const { target } = event;
  const element = pickUpIframe(target) || pickUpPhoneLink(target) || target;

  const { element: newHoveredElement, id: newHoveredElementId } =
    getNotDisabledLiveElement(element);
  const store = connectedStore.get();
  const state = store.getState();
  const focusedElementId = view.selectors.getFocusedElement(state);
  const currentFocusedElement = getLiveElement(focusedElementId);

  if (isSameOrContains(currentFocusedElement, newHoveredElement)) {
    return;
  }

  const currentHoveredElementId = view.selectors.getHoveredElement(state);

  if (newHoveredElementId !== currentHoveredElementId) {
    store.dispatch(view.actions.setHoveredElement(newHoveredElementId));
  }
};

export default elementHoverHandler;
